import { Icon, Button, If } from '@/components'

import styles from './styles.module.scss'

const SliderController = ({
  list,
  section = '',
  visibleElementIndex,
  variant = 'secondary',
  color = 'white',
  classname,
  hasButtons = false,
  onClick
}) => (
  <div className={`${styles.controllers} ${classname}`}>
    <div className={styles.indicators}>
      {list.map((_, index) => (
        <div
          key={`indicator-${index}`}
          className={`
            ${styles.item} 
            ${styles[`item--${color}`]} 
            ${visibleElementIndex === index && styles['item--active']}
          `}
        />
      ))}
    </div>
    <If condition={hasButtons}>
      <div className={styles.buttons}>
        <Button
          variant={variant}
          className={styles.buttonItem}
          id={`${section}-carouselPrevious-button`}
          disabled={visibleElementIndex === 0}
          aria-label="Voltar para o item anterior"
          onClick={() => onClick('left')}
        >
          <Icon name="arrow-left" />
        </Button>

        <Button
          variant={variant}
          className={styles.buttonItem}
          id={`${section}-carouselNext-button`}
          disabled={visibleElementIndex === list.length - 1}
          aria-label="Avançar para o próximo item"
          onClick={() => onClick('right')}
        >
          <Icon name="arrow-right" />
        </Button>
      </div>
    </If>
  </div>
)
export default SliderController
